import { createReducer, on } from "@ngrx/store";
import { OperatorsState } from "./operators.models";
import * as operatorsActions from './operators.actions';
import * as errorConstants from "../../shared/constants/error.constatnts";

export const initialOperatorsState: OperatorsState = {
    operators: [],
    mainOperator: null,
    currentOperator: null,
    loading: false,
    error: null
}

export const operatorsReducer = createReducer(
    initialOperatorsState,
    on(operatorsActions.LoadOperators, (state) => ({
        ...state,
        loading: true
    })),
    on(operatorsActions.LoadOperatorsSuccess, (state, { operators }) => ({
        ...state,
        operators,
        mainOperator: operators[0],
        loading: false
    })),
    on(operatorsActions.LoadOperatorsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    on(operatorsActions.SetCurrentOperator, (state, { currentOperatorId }) => ({
        ...state,
        loading: true,
    })),
    on(operatorsActions.SetCurrentOperatorSuccess, (state, { currentOperator }) => ({
        ...state,
        loading: false,
        currentOperator
    })),
    on(operatorsActions.SetCurrentOperatorFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),
    on(operatorsActions.LoadOperatorsOnLogin, (state) => ({
        ...state,
        loading: true
    })),
    on(operatorsActions.LoadOperatorsOnLoginSuccess, (state, { operators, defaultOperatorId }) => ({
        ...state,
        operators,
        mainOperator: operators.find(x => x.id === defaultOperatorId) ?? null,
        currentOperator: operators.find(x => x.id === defaultOperatorId) ?? null,
        loading: false
    })),
    on(operatorsActions.LoadOperatorsOnLoginFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error: error?.errorMessage ?? errorConstants.DefaultFeErrorMessage
    })),
    on(operatorsActions.MainOperatorStripeAccountStateChanged, (state, { operatorId, accountState, hasSubmittedOnboardingData }) => {
        if (!state.mainOperator || state.mainOperator.id !== operatorId) return state;

        const mainOp = { ...state.mainOperator, stripeAccountState: accountState, hasSubmittedOnboardingData: hasSubmittedOnboardingData }
        const mainIsCurrent = state.currentOperator?.id === state.mainOperator?.id;
        const currentOp = state.currentOperator;

        return {
            ...state,
            mainOperator: mainOp,
            currentOperator: mainIsCurrent ? mainOp : currentOp
        };
    })
);